import React from 'react';
import { useTranslation } from 'react-i18next';
import LabelItem from '../LabelItem';
import ListItem from '../ListItem';
import { ReactComponent as CustomersIcn } from '../../../../icons/customers-icon.svg';
import getColorClasses from '../../lib/getColorClasses';
import { Link } from 'react-router-dom';

const CustomerList = ({ currentPath }) => {
  const { t } = useTranslation('PAGES');
  const validPaths = ['/app/customers'];

  return (
    <ListItem>
      <Link to="/app/customers" className="flex">
        <CustomersIcn className={getColorClasses(currentPath, validPaths)} />
        <LabelItem className={getColorClasses(currentPath, validPaths)}>{t('MASTER_DATA')}</LabelItem>
      </Link>
    </ListItem>
  );
};

export default CustomerList;
